export const defaultDateFormat = "yyyy-MM-dd";
export const defaultTimestampFormat = "yyyy-MM-dd HH:mm:ss.SSS";
const maxMonthDay = 31;
const baseYear = 2000;

export const parseDate = (
	value: Date | string | number | { year: number; month: number; day: number; hour?: number; minute?: number; second?: number }
) => {
	if (!value) {
		return new Date(NaN);
	}

	if (typeof value === "number") {
		return new Date(value);
	}

	if (value instanceof Date) {
		return value;
	}

	if (typeof value === "object" && value!.year) {
		return new Date(value.year, value.month - 1, value.day, value.hour || 0, value.minute || 0, value.second || 0);
	}

	const [_fullMatch, firstComponent, delimiter, secondComponent, thirdComponent, tail] =
		/^(\d+)(\D)(\d+)\D(\d+)(.*)/.exec((value as string).trim()) || [];
	if (tail) {
		return new Date(value as string);
	}

	switch (delimiter) {
		case ".":
			return +firstComponent > maxMonthDay
				? new Date(+firstComponent, +secondComponent - 1, +thirdComponent)
				: new Date(+thirdComponent, +secondComponent - 1, +firstComponent);

		case "-":
			return new Date(+firstComponent, +secondComponent - 1, +thirdComponent);

		case "/":
			return new Date(
				+thirdComponent < baseYear ? baseYear + +thirdComponent : +thirdComponent,
				+firstComponent - 1,
				+secondComponent
			);

		default:
			return new Date(value as string);
	}
};
